import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiList, FiX } from "react-icons/fi";

function Header() {
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);

  const handleMobileNavToggle = () => {
    setIsMobileNavActive(!isMobileNavActive);
  };

  const handleNavigationClick = () => {
    if (isMobileNavActive) {
      setIsMobileNavActive(false);
    }
  };

  return (
    <header
      className={`${isMobileNavActive ? "mobile-nav-active" : ""}`}
      id="header"
    >
      <button
        className={`mobile-nav-toggle ${isMobileNavActive ? "active" : ""}`}
        onClick={handleMobileNavToggle}
      >
        {isMobileNavActive ? (
          <FiX />
        ) : (
          <i className="bi bi-three-dots-vertical"></i>
        )}
      </button>

      <div className="d-flex flex-column">
        <div className="profile">
          <img
            src={process.env.PUBLIC_URL + "/isaiah.jpeg"}
            alt=""
            className="img-fluid rounded-circle"
          />
          <h1 className="text-light">
            <NavLink to="/devwork" id="name" onClick={handleNavigationClick}>
              Isaiah Chiraira
            </NavLink>
          </h1>
          <div className="social-links mt-3 text-center">
            <a href="https://twitter.com/Techy_Gui" className="twitter">
              <i className="bi bi-twitter"></i>
            </a>
            <a
              href="https://www.facebook.com/tadiwanashe.chiraira"
              className="facebook"
            >
              <i className="bi bi-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/tadiwanashechiraira/"
              className="instagram"
            >
              <i className="bi bi-instagram" id="icon"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/isaiah-c-457322141"
              className="linkedin"
            >
              <i className="bi bi-linkedin"></i>
            </a>
            <a href="#" className="whatsapp">
              <i className="bi bi-whatsapp"></i>
            </a>
            <a href="#" className="github">
              <i className="bi bi-github"></i>
            </a>
          </div>
        </div>
        <nav id="navbar" className="nav-menu navbar">
          <ul>
            <li>
              <NavLink
                exact
                to="/devwork"
                className="nav-link scrollto"
                activeClassName="active"
                onClick={handleNavigationClick}
              >
                <i className="bi bi-house"></i> <span>Home</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className="nav-link scrollto"
                activeClassName="active"
                onClick={handleNavigationClick}
              >
                <i className="bi bi-person"></i> <span>About</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/resume"
                className="nav-link scrollto"
                activeClassName="active"
                onClick={handleNavigationClick}
              >
                <i className="bi bi-file-pdf"></i> <span>Resume</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/projects"
                className="nav-link scrollto"
                activeClassName="active"
                onClick={handleNavigationClick}
              >
                <i className="bi bi-collection"></i> <span>Projects</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services"
                className="nav-link scrollto"
                activeClassName="active"
                onClick={handleNavigationClick}
              >
                <i className="bi bi-hdd-rack"></i> <span>Services</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className="nav-link scrollto"
                activeClassName="active"
                onClick={handleNavigationClick}
              >
                <i className="bi bi-envelope"></i> <span>Contact</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
